import { ColorsSchemeNames } from '@rst/ui-ts'

type ConvertColorType = (
	inputColor?: string,
	params?: { noneAllowed?: boolean }
) => ColorsSchemeNames

export const convertColor: ConvertColorType = (inputColor, params) => {
	if (!inputColor || inputColor === 'none')
		return (params?.noneAllowed ? 'none' : 'gray-01') as ColorsSchemeNames
	if (inputColor in relations) return relations[inputColor]
	return inputColor as ColorsSchemeNames
}

const relations: Record<string, ColorsSchemeNames> = {
	white: 'gray-01',
	dark: 'gray-20',
	black: 'gray-20',
}
